
import { Component, Vue } from 'vue-property-decorator'
import SimpleTable from '@/components/busi/table/simple-table.vue'
import Tree from '@/components/busi/custom/tree.vue'
import DictSelect from '@/components/busi/custom/dictselect.vue'
import { querySchoolListByBusinessId, querySchoolListByBusinessIdCount, enable, disable, getGradeSubjectListNoPage } from '@/api/enrollmentinformation'
import { checkPermission } from '@/utils/permission'
import { MessageBox } from 'element-ui'
import { UserModule } from '@/store/modules/user'

@Component({
  name: 'enrollmentinformation',
  components: {
    DictSelect,
    SimpleTable,
    Tree
  }
})
export default class EnrollmentInformation extends Vue {
  private loading = !1

  private tableData = {
    list: [],
    totalCount: 1
  }

  get schoolDetailEnable () {
    return !checkPermission(['schoolDetailEnable'])
  }

  private columns = [
    {
      prop: 'schoolCode',
      label: '院校代码'
    },
    {
      prop: 'schoolName',
      label: '院校名称'
    },
    {
      prop: 'title',
      label: '简章标题'
    },
    {
      prop: 'schoolState',
      label: '状态',
      custom: !0
    },
    {
      prop: 'createTimeStamp',
      label: '创建时间',
      format: 'date'
    },
    {
      prop: 'endTimeStamp',
      label: '结束时间',
      format: 'date'
    }
  ]

  private dataSet (tableData: any) {
    this.$router.push({
      name: 'dataset',
      params: {
        flag: 'edit',
        detailId: tableData.detailId,
        schoolId: tableData.id,
        schoolName: tableData.schoolName,
        studyName: tableData.studyName,
        businessName: tableData.businessName
      }
    })
  }

  private showDetail (tableData: any) {
    this.$router.push({
      name: 'dataset',
      params: {
        flag: 'show',
        detailId: tableData.detailId,
        schoolId: tableData.id,
        schoolName: tableData.schoolName,
        studyName: tableData.studyName,
        businessName: tableData.businessName
      }
    })
  }

  private pagination: any = {
    currentPage: 1,
    pageSize: 10
  }

  private form = {}

  private handleNodeClick (data: any) {
    this.loading = !0
    this.form = {
      businessId: data.businessId
    }
    this.onQuery()
  }

  private onReset () {
    this.form = {}
    this.onQuery()
  }

  private async onQuery (pagination: any = null) {
    !pagination && (this.pagination.currentPage = 1)
    await querySchoolListByBusinessId({
      ...this.form,
      ...pagination || this.pagination
    }).then(async (res: any) => {
      await querySchoolListByBusinessIdCount({ ...this.form }).then((resCount: any) => {
        this.loading = !1
        this.tableData.list = res.object.list
        this.tableData.totalCount = resCount.object.totalCount
      })
    }).catch((err: any) => {
      console.log('err', err)
      this.loading = !1
    })
  }

  private async change (row: any) {
    if (row.schoolState === 1) {
      row.schoolState = 0
      if (!row.detailId) {
        this.$alert('请先配置数据!')
        row.schoolState = 0
      } else {
        await getGradeSubjectListNoPage({ schoolId: row.id }).then(async (res: any) => {
          if (res.code === 10000) {
            if (res.object.list.length === 0) {
              this.$alert('请先配置保存年级专业数据', { type: 'error' })
              row.schoolState = 0
              return
            }
            MessageBox.confirm(
              '确认要启用吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
              }).then(() => {
              enable({ id: row.detailId })
              row.schoolState = 1
            }).catch((e) => {
              console.log(e)
            })
          }
        })
      }
    } else {
      row.schoolState = 1
      MessageBox.confirm(
        '确认要禁用吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(() => {
        disable({ id: row.detailId })
        row.schoolState = 0
      }).catch((e) => {
        console.log(e)
      })
    }
  }

  get userId () {
    return UserModule.id
  }

  mounted () {
    // 留学中心办账号登录显示“结束时间”，否则显示“创建时间”
    console.log('userId:', this.userId)
    if (this.userId === '890') {
      this.columns.splice(this.columns.length - 2, 1)
    } else {
      this.columns.splice(this.columns.length - 1, 1)
    }
    this.onQuery()
  }
}
